export default {
  pageTitle: {
    text: "Request Appeal",
  },
  sections: [
    {
      fields: [
        {
          machine_name: "fileType",
          value: "Appeal Request",
          widget: "text",
          style: {
            display: "none",
          },
        },
        {
          machine_name: "files",
          widget: "file_upload",
          file_upload: { fileType: "Appeal Request" },
          accept_multiple: false,
          required: true,
          validate: ["required", "file_required"],
          checkFilesAdded: true,
          documentAuth: "dh",
        },
        {
          machine_name: "document_description",
          widget: "text",
          label: "Document Description",
          validate: ["required"],
          maxLength: 100,
        },
        {
          machine_name: "case_note",
          widget: "text_area",
          label: "Case Note",
          inputLimit: 4000,
          rows: 7,
        },
      ],
    },
  ],
};
